import React, { useEffect, useState } from 'react';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import {
    ExpenseHistoryDataForm,
    ExpenseHistoryFilter
} from '../../../../app/models/ExpenseHistory';
import { momentParseDate } from '../../../../helpers';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';

interface Props {
    expenseHistories: ExpenseHistoryDataForm[];
    totalRows: number;
    filter: ExpenseHistoryFilter;
    setFilter: (filter: ExpenseHistoryFilter) => void;
    edit?: (id: number) => void;
    loading?: boolean;
}

const ExpenseHistoryDataTable = ({
    expenseHistories,
    totalRows,
    filter,
    setFilter,
    edit,
    loading = false
}: Props) => {
    const columns = [
        {
            name: 'Fecha',
            selector: (row: any) => row?.created_at,
            sortable: true,
            sortField: 'created_at',
            width: '155px',
            cell: (row: ExpenseHistoryDataForm) => (
                <span className="">{momentParseDate(row?.created_at, 'YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            name: 'Acción',
            selector: (row: any) => row?.status,
            sortable: true,
            sortField: 'status',
            cell: (row: ExpenseHistoryDataForm) => <span className="">{row.status}</span>
        },
        {
            name: 'Creado por',
            selector: (row: any) => row.created_user,
            sortable: true,
            sortField: 'created_user',
            cell: (row: ExpenseHistoryDataForm) => 
            <span
                className=""
                dangerouslySetInnerHTML={{ __html: row.created_user ? row.created_user : '' }}
            ></span>
        },
        {
            name: 'Comentario',
            selector: (row: any) => row.user,
            sortable: true,
            sortField: 'user',
            cell: (row: ExpenseHistoryDataForm) => <span className="">{row.comment}</span>
        },
        // {
        //     name: 'Acciones',
        //     selector: (row: any) => row?.id,
        //     sortable: false,
        //     width: '150px',
        //     cell: (row: ExpenseHistoryDataForm, index: any, column: any) => {
        //         return (
        //             <div className="">
        //                 {edit && !row.is_approved && (
        //                     <ButtonTableAction
        //                         callbackFunction={() => edit(row?.id ?? -1)}
        //                         classIcon={'mdi mdi-pencil'}
        //                         colorIcon={'text-warning'}
        //                         errorMessage={'No se puede editar este registro.'}
        //                         title={'Editar'}
        //                     />
        //                 )}
        //             </div>
        //         );
        //     }
        // }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={expenseHistories}
            progressPending={loading}
            isMobileStacked={true}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default ExpenseHistoryDataTable;
